"use client";

import Icon from "@/components/Icon";
import { SocialIconLinkedIn, SocialIconX } from "@/layouts/Footer";
import { cn } from "@/lib/utils";
import { useState } from "react";

export const SocialShare = ({
	url,
	title,
	className,
}: {
	url: string;
	title: string;
	className?: string;
}) => {
	const [copied, setCopied] = useState(false);

	const shareOnTwitter = () => {
		const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`;
		window.open(twitterUrl, "_blank", "noopener,noreferrer");
	};

	const shareOnLinkedIn = () => {
		const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
		window.open(linkedInUrl, "_blank", "noopener,noreferrer");
	};

	const copyLink = async () => {
		try {
			await navigator.clipboard.writeText(url);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		} catch (_err) {
			//
		}
	};

	return (
		<div className={cn("flex items-center gap-2", className)}>
			<button
				onClick={shareOnTwitter}
				className="rounded-md p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
				title="Share on Twitter"
			>
				<SocialIconX className="size-4" />
			</button>

			<button
				onClick={shareOnLinkedIn}
				className="rounded-md p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
				title="Share on LinkedIn"
			>
				<SocialIconLinkedIn className="size-4" />
			</button>

			<button
				onClick={copyLink}
				className="rounded-md p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
				title={copied ? "Copied!" : "Copy link"}
			>
				<Icon
					name={copied ? "Check" : "Link"}
					className={cn({
						"text-green-500": copied,
					})}
					size={16}
				/>
			</button>
		</div>
	);
};
